import { t } from "@/i18n-js/instance";
import { usePlanTrialBanner } from "@/react/components/Layout/TrialBanner/usePlanTrialBanner";
import { useManagePlanTrialModal } from "@/react/components/shared/UpgradePlan/PlanDetails/ManagePlanTrialModal";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import { InfoWrapper } from "./InfoWrapper";

export const PlanTrialBanner = () => {
  const {
    isPlanTrialActive,
    planTrialEndDateFormatted,
    planTrialDaysLeft,
    planTrial,
  } = usePlanTrialBanner();
  const { trackEvent } = useEventsTracker();
  const managePlanTrialModal = useManagePlanTrialModal();

  if (!isPlanTrialActive) {
    return null;
  }

  const handleOnClick = () => {
    trackEvent("trial_banner.plans_page.manage_trial.clicked", {
      days_left: planTrialDaysLeft,
      is_plan_trial: true,
      trial_type: planTrial?.trial_type,
    });
    void managePlanTrialModal.show();
  };

  return (
    <InfoWrapper>
      <Typography.LabelLg weight="semibold">
        {t("plan_trial_plans_page_banner.title", {
          date: planTrialEndDateFormatted,
        })}
      </Typography.LabelLg>
      <Typography.BodyMd color="text-default">
        {t("plan_trial_plans_page_banner.description")}
      </Typography.BodyMd>
      <div className="mt-4">
        <Button variant="secondary" onClick={handleOnClick}>
          {t("plan_trial_plans_page_banner.manage_trial")}
        </Button>
      </div>
    </InfoWrapper>
  );
};
